<app-side-menu>
  <div class="department-form-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-secondary me-3"
              (click)="onCancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-building me-3"></i>
                {{ isEditMode ? 'Editar Departamento' : 'Novo Departamento' }}
              </h1>
              <p class="page-subtitle">
                {{ isEditMode ? 'Atualize os dados do departamento' : 'Cadastre um novo departamento no sistema' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-lg-8 col-xl-6">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="departmentForm" (ngSubmit)="onSubmit()">
              <!-- Nome do Departamento -->
              <div class="mb-3">
                <label for="name" class="form-label">
                  Nome do Departamento <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  [class.is-invalid]="isFieldInvalid('name')"
                  formControlName="name"
                  placeholder="Ex: Recursos Humanos">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
                <small class="form-text text-muted">
                  Nome do departamento (mínimo 3 caracteres)
                </small>
              </div>

              <!-- Descrição -->
              <div class="mb-3">
                <label for="description" class="form-label">
                  Descrição
                </label>
                <textarea
                  id="description"
                  class="form-control"
                  [class.is-invalid]="isFieldInvalid('description')"
                  formControlName="description"
                  rows="4"
                  placeholder="Descreva as responsabilidades e funções do departamento"></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
                <small class="form-text text-muted">
                  Descrição opcional do departamento (máximo 500 caracteres)
                </small>
              </div>

              <!-- Botões de Ação -->
              <div class="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="onCancel()"
                  [disabled]="isSubmitting">
                  Cancelar
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="isSubmitting || departmentForm.invalid">
                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                  <i *ngIf="!isSubmitting" class="fas fa-save me-2"></i>
                  {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
